export const ACCOUNT_NUMBER = "1009044020";
export const UEN_NUMBER = "201727751RHC1";
export const MERCHANT_NAME = "Luce Maintenance Group Pte. Ltd.";
